/**
 * 贝盈 X98：8815 机芯（Device8815）与 X98 8K web-hid 可能共用「displayname=X98 + keyboardType=98」，
 * 仅用字符串会误判。仅下列 VID+PID 走 8815（与 supportedDevices 中 X98 1K 条目一致）。
 */

export type BeiyingX981KEquipmentLike = {
  vendorId?: number;
  productId?: number;
  keyboardType?: string;
  displayname?: string;
  productName?: string;
  solutionRovider?: string;
};

/**
 * 必须使用 `Device8815.open()` 的 X98（8815），与 X98 8K（0x372e:0x10b0 等 web-hid）区分。
 */
export const BEIYING_X98_DEVICE8815_VENDOR_PRODUCT: ReadonlyArray<{
  vendorId: number;
  productId: number;
}> = [
  { vendorId: 0x258a, productId: 0x01b9 },
  { vendorId: 0x258a, productId: 0x0233 },
];

/** @deprecated 请用 BEIYING_X98_DEVICE8815_VENDOR_PRODUCT */
export const BEIYING_X98_1K_VENDOR_PRODUCT_IDS =
  BEIYING_X98_DEVICE8815_VENDOR_PRODUCT;

export function isBeiyingDevice8815X98Keyboard(
  eq: BeiyingX981KEquipmentLike | null | undefined
): boolean {
  if (!eq) return false;
  const vid = Number(eq.vendorId);
  const pid = Number(eq.productId);
  if (!Number.isFinite(vid) || !Number.isFinite(pid)) return false;
  return BEIYING_X98_DEVICE8815_VENDOR_PRODUCT.some(
    (p) => p.vendorId === vid && p.productId === pid
  );
}

/** 改键页隐藏 Mac 层等与「仅 8815 X98」一致的 UI */
export function isBeiyingX981KDevice(
  eq: BeiyingX981KEquipmentLike | null | undefined
): boolean {
  return isBeiyingDevice8815X98Keyboard(eq);
}
